/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFishbone = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M21.753 4.658 15.328 12l6.425 7.342-1.506 1.316L13.546 13h-3.092l-6.701 7.658-1.506-1.316L8.671 12 2.247 4.658l1.506-1.316L10.454 11h3.092l6.701-7.658z" />
        <path d="M14 19h-4v-2h4zm-9-6H2v-2h3zm17 0h-3v-2h3zm-8-6h-4V5h4z" />
      </g>
    </g>
  </Icon>
);
export { SvgFishbone as Fishbone };
